import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { FC } from 'react';

import { InfoBlockProps } from '../InfoBlock';
import TemplateVideoSliderWithInfo from '../templates/TemplateVideoSliderWithInfo';
import TemplateWithInfo from '../templates/TemplateWithInfo';

export type VideoTemplateProps = {
  info: InfoBlockProps;
  onModalClose(): void;
};

const VideoTemplate: FC<VideoTemplateProps> = ({ info, onModalClose }) =>
  isMobileOrIPad() ? (
    <TemplateVideoSliderWithInfo {...{ info }} onBack={onModalClose} />
  ) : (
    <TemplateWithInfo {...{ info, onModalClose }} />
  );

export default VideoTemplate;
